import React, { ReactElement } from 'react';
import cn from 'classnames';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import styles from './StateBasedFadeTransition.module.scss';

// <T extends string> means that T should be a union type
type StateBasedFadeTransitionProps<T extends string> = {
  state: T;
  elementByStateMap: { [K in T]: ReactElement };
  duration?: 'fast' | 'medium' | 'slow';
};

const StateBasedFadeTransition = <T extends string>({
  state,
  elementByStateMap,
  duration = 'fast',
}: StateBasedFadeTransitionProps<T>) => {
  return (
    <SwitchTransition>
      <CSSTransition
        key={state}
        classNames={{
          enter: styles.elEnter,
          enterActive: cn(styles.elEnterActive, styles[duration]),
          exit: cn(styles.elExit, styles[duration]),
        }}
        // this is really weird, because this matches the documentation
        // @ts-ignore
        addEndListener={(node: HTMLElement, done) => {
          node.addEventListener('transitionend', done, false);
        }}
      >
        <>{elementByStateMap[state]}</>
      </CSSTransition>
    </SwitchTransition>
  );
};

export default StateBasedFadeTransition;
